import { render, staticRenderFns } from "./TempoChoice.vue?vue&type=template&id=18ca1706&"
import script from "./TempoChoice.vue?vue&type=script&lang=ts&"
export * from "./TempoChoice.vue?vue&type=script&lang=ts&"
import style0 from "./TempoChoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports